var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5405 6C17.5405 5.64119 17.3465 5.40556 16.9583 4.93429C15.5382 3.21014 12.406 0 8.77027 0C5.13454 0 2.00233 3.21014 0.582243 4.93429C0.194081 5.40556 0 5.64119 0 6C0 6.35881 0.194081 6.59444 0.582243 7.06571C2.00233 8.78986 5.13454 12 8.77027 12C12.406 12 15.5382 8.78986 16.9583 7.06571C17.3465 6.59444 17.5405 6.35881 17.5405 6ZM8.77027 9C10.4271 9 11.7703 7.65685 11.7703 6C11.7703 4.34315 10.4271 3 8.77027 3C7.11342 3 5.77027 4.34315 5.77027 6C5.77027 7.65685 7.11342 9 8.77027 9Z",
    fill: "#CCD2E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/password-eye.fd2992c3630de635e61eda64227987a4.svg";
export { ForwardRef as ReactComponent };